import { Link } from 'react-router-dom'
import styles from './CustomButton.module.scss'
import classNames from 'classnames'
import { Typography } from '..'

export const CustomButton = ({
  variant,
  actionType,
  children,
  to,
  target,
  onClick,
  type,
  className,
  disabled,
  isTextBtn = true
}) => {

  const classNamedGenerated = classNames(
    styles.general,
    styles[variant],
    disabled && styles.disabled,
    className
  )

  const ButtonComponent = actionType === 'link' ? Link : 'button'
  const actionAttributes = actionType === 'link' ? { to,target } : { onClick,type }

  return (
    <ButtonComponent
      className={classNamedGenerated}
      {...actionAttributes}
    >
      {isTextBtn ? <Typography variant='h6regular'>{children}</Typography> : children}
    </ButtonComponent>
  )
}
